import { Stack } from "@mui/joy";
import { memo } from "react";
import { EntitiesSearch } from "components/base";

interface DataLabConnectionTableRowActionsProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
}

const DataLabConnectionTableToolbar =
  memo<DataLabConnectionTableRowActionsProps>(
    ({ searchValue, onSearchChange }) => {
      return (
        <Stack direction="row" sx={{ width: "280px" }}>
          <EntitiesSearch
            onChange={(event) => onSearchChange(event.target.value)}
            onClear={() => onSearchChange("")}
            placeholder="Search"
            value={searchValue}
          />
        </Stack>
      );
    }
  );
DataLabConnectionTableToolbar.displayName = "DataLabConnectionTableToolbar";

export default DataLabConnectionTableToolbar;
